import { CSSProperties, FC, useCallback, useContext, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { Link } from 'react-router'

import { List, Typography } from 'antd'
import { useResponsive } from 'antd-style'

import slugify from 'slugify'

import { Title } from '../../components/text/Title'

import { Context } from './Context'

const TableOfContent: FC = () => {
  const { heading } = useContext(Context)
  const { desktop } = useResponsive()
  const { formatMessage } = useIntl()
  const scrollToHeading = useCallback((heading: string) => {
    const element = window.document?.querySelector(`#${heading}`)

    if (element) {
      element.scrollIntoView({ behavior: 'auto' })
    }
  }, [])

  const [headings, setHeadings] = useState<{ label: string; key: string, style: CSSProperties }[]>([])

  useEffect(() => {
    const elements = Array.from(document.querySelectorAll<HTMLHeadingElement>('h2,h3')).map((it) => ({
      label: it.innerText,
      key: slugify(it.innerText).toLowerCase(),
      style: { paddingLeft: it.tagName.toLowerCase() === 'h2' ? 0 : 16 },
    }))
    setHeadings(elements)
  }, [])

  if (!desktop) return null

  return headings.length > 0 ? (
    <List
      style={{ marginLeft: 40 }}
      header={<Title level={5}>{formatMessage({ id: 'article.table-of-contents' })}</Title>}
      dataSource={headings}
      renderItem={(item) => (
        <List.Item style={{ textDecorationStyle: 'dashed', ...item.style }}>
          {item.key !== heading ? (
            <Link to={{ hash: item.key }} onClick={() => scrollToHeading(item.key)}>
              {item.label}
            </Link>
          ) : (
            <Typography.Text>{item.label}</Typography.Text>
          )}
        </List.Item>
      )}
    />
  ) : null
}

export { TableOfContent }
